/** Any member may add one, so the group needs its own ceiling beyond the write rate limit. */
export const MAX_PLACEHOLDERS_PER_GROUP = 50;

/** The API's answer once a group holds MAX_PLACEHOLDERS_PER_GROUP spots. */
export const PLACEHOLDER_LIMIT_ERROR_KEY = 'errors:placeholders.limitReached';
